import React from "react";
import "./Brand.css";

const brands = [
  { id: 1, name: "Kirkland Signature", img: "/images/m1.webp" },
  { id: 2, name: "Nature Made", img: "/images/m2.jpg" },
  { id: 3, name: "Nature Bounty", img: "/images/m3.avif" },
  { id: 4, name: "Neocell", img: "/images/m4.png" },
  { id: 5, name: "Walmart", img: "/images/m5.webp" },
  { id: 6, name: "Costco", img: "/images/m6.webp" },
  { id: 7, name: "SAMS CLUB", img: "/images/m7.jpg" },
  { id: 8, name: "ALLSTARHEALTH", img: "/images/all.png" },
];

const features = [
  { id: 1, title: "Livraison", desc: "....", icon: "🚚" },
  { id: 2, title: "Shipping USA - LOME", desc: "....", icon: "↩️" },
  { id: 3, title: "Service Client", desc: "Friendly 24/7 customer support", icon: "🎧" },
  { id: 4, title: "Money Back Guarantee", desc: "Quality checked by our team", icon: "🛡️" },
];

export default function Brand() {
  return (
    <section className="brand-section-brand">
      <div className="brand-header-brand">
        <h2 className="brand-title-brand">Plus de 10 Marques</h2>
      </div>

      <div className="brand-logos-brand">
        {brands.map((b) => (
          <div key={b.id} className="brand-card-brand">
            <img src={b.img} alt={b.name} />
          </div>
        ))}
      </div>

      <div className="brand-features-brand">
        {features.map((f) => (
          <div key={f.id} className="brand-feature-brand">
            <div className="icon-brand">{f.icon}</div>
            <div>
              <h4>{f.title}</h4>
              <p>{f.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
